(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const desktop = window.matchMedia('(min-width: 769px)');
    let frame;
    const updateBrandsMenu = () => {
      frame = null;
      const menu = document.getElementById('megamenu_items-shop-brands');
      if (!menu) return;
      if (!desktop.matches) {
        menu.style.removeProperty('--brands-menu-available-height');
        return;
      }
      const top = menu.parentElement.getBoundingClientRect().bottom;
      menu.style.setProperty('--brands-menu-available-height',
        Math.max(0, window.innerHeight - top - 24) + 'px');
    };
    const scheduleUpdate = () => {
      if (!frame) frame = window.requestAnimationFrame(updateBrandsMenu);
    };
    document.addEventListener('pointerover', scheduleUpdate);
    document.addEventListener('focusin', scheduleUpdate);
    document.addEventListener('shopify:section:load', scheduleUpdate);
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('load', scheduleUpdate);
    desktop.addEventListener('change', scheduleUpdate);
    scheduleUpdate();
  })();

  } catch(e) { console.error(e); }
})();
})();
